// extracted by mini-css-extract-plugin
export var active = "PagePressreleaseLanding-module--active---AJa7";
export var filter = "PagePressreleaseLanding-module--filter--v2Ogd";
export var readMoreButton = "PagePressreleaseLanding-module--readMoreButton--+zx3f";
export var title = "PagePressreleaseLanding-module--title--2YIvl";
export var wrapper = "PagePressreleaseLanding-module--wrapper--KPfjX";